import React from 'react';
import '../assets/CU4A4071.jpg';

const Quote = () => {
  return (
    <section className="quote-section">
      <div className="quote-container">
        <blockquote className="confucian-quote">
          <p>
            ¿Me preguntas por qué compro arroz y flores?<br />
            Compro arroz para vivir y flores para tener algo por lo que vivir.
          </p>
          <cite>Confucio</cite>
        </blockquote>
      </div>
    </section>
  );
};

export default Quote;
